
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15","cy":"8","r":"3","stroke":"#2E50D4","stroke-width":"2"}}),_c('path',{attrs:{"d":"M21 20a6 6 0 00-12 0M6 6v6M9 9H3","stroke":"#2E50D4","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    